import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';

import {OrderList} from '../../../components/orderlist/OrderList';

import {TenantInvoiceSettingMasterService} from '../../../he-thong/cau-hinh-hoa-don/TenantInvoiceSettingMasterService';
import {InvoiceSettingDefaultService} from '../../../he-thong/cau-hinh-hoa-don/InvoiceSettingDefaultService';

import {Toolbar} from './Toolbar';
import {OrderForm} from './OrderForm';
import {useTranslation} from '../../../../shared/language';

export const Menu3 = (props) => {
  const {t} = useTranslation();

  const {tenantInvoiceSettingMasterId, invoiceType} = props.attribute;
  const previewListRefreshToken = props.previewListRefreshToken ?? 0;

  const [formId, setFormId] = useState('');
  const [formSetting, setFormSetting] = useState({
    dragdrop: false
  });
  const [groupCode, setGroupCode] = useState('');

  const [fieldId, setFieldId] = useState('');
  const [fieldDeletable, setFieldDeletable] = useState(false);
  const [targetId, setTargetId] = useState('');
  const [targetSetting, setTargetSetting] = useState({});

  const [items, setItems] = useState([]);

  const [invoiceSettings, setInvoiceSettings] = useState(null);

  const [display, setDisplay] = useState(false);
  const [settings, setSettings] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [selectedSetting, setSelectedSetting] = useState(null);

  useEffect(() => {
    if (!invoiceSettings?.length) {
      return;
    }
    const doc = props.preview.current?.contentWindow?.document;
    const templateRoot = doc?.getElementById('template-preview');
    if (!templateRoot) {
      return;
    }

    const event = new CustomEvent('addSelectListener');
    props.dispatchEvent(event);

    const onSelect = (event) => {
      const d = event.detail;
      if (!d?.formId || !d?.items) {
        return;
      }
      setFormId(d.formId);
      setFormSetting(d.formSetting);
      setGroupCode(d.groupCode);
      setItems(d.items);
    };
    templateRoot.addEventListener('onSelect', onSelect);
    return () => {
      templateRoot.removeEventListener('onSelect', onSelect);
    };
  }, [invoiceSettings, props.previewContentVersion]);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tenantInvoiceSettingMasterId) {
      TenantInvoiceSettingMasterService.get(tenantInvoiceSettingMasterId).then(data => {
        setInvoiceSettings(data.invoiceSettings);
      });
    } else {
      if (invoiceType && invoiceType.id) {
        InvoiceSettingDefaultService.getList({typeInvoiceId: invoiceType.id, maxResultCount: 1000}).then(({items}) => {
          setInvoiceSettings(items);
        });
      }
    }
  }, [tenantInvoiceSettingMasterId, invoiceType]);

  useEffect(() => {
    if (groupCode && invoiceSettings) {
      const _settings = [];
      invoiceSettings.forEach(setting => {
        if (groupCode.includes(setting.groupTypeCode)) {
          _settings.push({value: setting.fieldName, label: setting.lable});
        }
      });
      setSettings(_settings);
    }
  }, [groupCode, invoiceSettings]);

  /** loadForm sau khi iframe đã setText (Modify dùng queueMicrotask tăng previewListRefreshToken để tránh chạy trước parent effect). */
  useEffect(() => {
    if (!formId) {
      return;
    }
    const event = new CustomEvent('loadForm', { detail: { selector: formId } });
    props.dispatchEvent(event);
  }, [formId, previewListRefreshToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectField = (target) => {
    if (target && target.targetId) {
      setFieldId(target.fieldId);
      setFieldDeletable(target.addedField === 'Y');
      setTargetId(target.targetId);
      setTargetSetting(target.targetSetting);

      // let event = new CustomEvent('setCss', {
      //   detail: {selector: `.chinhSua`, property: 'background', value: ``}
      // });
      // props.dispatchEvent(event);

      // event = new CustomEvent('setCss', {
      //   detail: {selector: `#${target.targetId}`, property: 'background', value: `rgb(179, 230, 247)`}
      // });
      // props.dispatchEvent(event);
    } else {
      setFieldId(null);
      setFieldDeletable(false);
      setTargetId(null);
      setTargetSetting({});

      // let event = new CustomEvent('setCss', {
      //   detail: {selector: `.chinhSua`, property: 'background', value: ``}
      // });
      // props.dispatchEvent(event);
    }
  }

  const onRowReorder = (orderedItems) => {
    setItems(orderedItems);
    let event = new CustomEvent('reorder', {
      detail: {selector: formId, value: orderedItems}
    });
    props.dispatchEvent(event);
  }

  const showEditField = (field) => {
    if (field) {
      setSelectedField(field);
      setDisplay(true);
      if (field.databind) {
        setSelectedSetting(field.databind);
      } else {
        setSelectedSetting(null);
      }
    }
  }

  const onEditFieldSubmit = () => {
    let event;
    switch (selectedField.groupCode) {
      case '05':
        event = new CustomEvent('setAttr', {
          detail: {selector: `#tr-bc4-2 > tr:first-child td:eq(${selectedField.fieldIndex}) > font`, property: 'databind', value: selectedSetting}
        });
        break;
      default:
        event = new CustomEvent('setAttr', {
          detail: {selector: `#${selectedField.valueTarget}`, property: 'databind', value: selectedSetting}
        });
    }
    props.dispatchEvent(event);
    setDisplay(false);

    event = new CustomEvent('loadForm', {
      detail: {selector: formId}
    });
    props.dispatchEvent(event);
    props.onAfterTemplateFieldSave?.();
  }

  const itemTemplate = (item) => {
    return (
      <OrderForm field={item} selectField={selectField} dispatchEvent={props.dispatchEvent} showEditField={showEditField}/>
    );
  }

  return (
    <Fragment>
      <div className="grid mt-2">
        <div className="col-12 pb-0">
          <Toolbar formId={formId} formSetting={formSetting} fieldId={fieldId} fieldDeletable={fieldDeletable} targetId={targetId} targetSetting={targetSetting}
                   selectField={selectField} dispatchEvent={props.dispatchEvent}/>
        </div>
      </div>
      <hr className="mt-0"/>
      <div className="iam-scroll pt-0 pb-0" style={{height: (props.windowHeight - 373.5) + 'px', overflow: 'hidden auto'}}>
        <div className="grid">
          {invoiceSettings &&
              <div className="col-12">
                {formId
                  ? <Fragment>
                    <OrderList value={items} dragdrop={formSetting.dragdrop} dataKey="fieldId"
                               itemTemplate={itemTemplate} onChange={(e) => onRowReorder(e.value)} className="template-editor-controls"/>
                  </Fragment>
                  : <div className="image-uploader">
                    <i className="pi pi-reply"/>
                    <p>{t('templatePreview.editContentHint')}</p>
                  </div>
                }
              </div>
          }
          {!invoiceSettings &&
              <div className="col-12">
                  <div className="image-uploader">
                      <i className="pi pi-info-circle"/>
                      <p>{t('templatePreview.noGeneralConfig')}</p>
                  </div>
              </div>
          }
        </div>
      </div>
      <Dialog header={t('templatePreview.chooseField')} visible={display} style={{width: '40rem'}} onHide={() => setDisplay(false)} className="no-scroll">
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-12">
            <Dropdown value={selectedSetting} options={settings} onChange={e => setSelectedSetting(e.value)} filter={true}/>
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.save')} icon="pi pi-check" onClick={onEditFieldSubmit} className="p-button-sm mr-2"/>
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    </Fragment>
  );
}




